import React from 'react';

const FceAdmin = () => {};

export default FceAdmin;
